import { render } from "./AuthorsManagement.vue?vue&type=template&id=d3b12ad0&scoped=true"
import script from "./AuthorsManagement.vue?vue&type=script&lang=js"
export * from "./AuthorsManagement.vue?vue&type=script&lang=js"

import "./AuthorsManagement.vue?vue&type=style&index=0&id=d3b12ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b12ad0"]])

export default __exports__